import Text from "components/Text";
import styled, { css, keyframes } from "styled-components";
import { ButtonProps } from "./types";

const variantStyle = ({ variant, disabled }: ButtonProps) => {
    switch (variant) {
        case "filled":
            return css`
                background: ${disabled ? "#bdbdbd" : "#8868EA"};
                color: #fff;
                border-color: ${disabled ? "#bdbdbd" : "#8868EA"};
            `;

        case "outlined":
            return css`
                background: ${disabled ? "#ececec" : "#ffffff"};
                color: ${disabled ? "#bdbdbd" : "#8868EA"};
                border-color: ${disabled ? "#bdbdbd" : "#8868EA"};
            `;

        case "flat":
            return css`
                background: ${disabled ? "#bdbdbd" : "#F3F0FD"};
                color: ${disabled ? "#fff" : "#8868EA"};
                border: none;
            `;
    }
};

const hover = ({ disabled }: ButtonProps) => {
    if (!disabled) {
        return css`
            &:hover {
                transition: 0.15s all ease-in-out;
                box-shadow: 0px 4px 14px rgba(136, 104, 234, 0.3);
            }
        `;
    }
};

const sizeStyle = ({ size, isLoading }: ButtonProps) => {
    switch (size) {
        case "small":
            return css`
                padding: 12px 24px;
            `;
        case "medium":
            return css`
                padding: 16px 32px;
            `;
        case "large":
            return css`
                padding: 20px 40px;
            `;
        default:
            return css`
                padding: 12px 24px;
            `;
    }
};

const rotation = keyframes`
    from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg)
        }
        to {
            transform: rotate(359deg)
        }
`;

export const StyledButton = styled("button")<ButtonProps>`
    border-radius: 40px;
    outline: none;
    display: flex;
    flex-direction: ${(props) =>
        props.iconPosition === "prefix" ? "row" : "row-reverse"};
    justify-content: center;
    align-items: center;
    position: relative;
    column-gap: 0.3rem;
    border-style: solid;
    border-width: 1.5px;
    width: ${({ fullWidth }) => fullWidth && "100%"};
    cursor: ${({ disabled, isLoading }) =>
        disabled ? "not-allowed" : isLoading ? "unset" : "pointer"};
    height: fit-content;
    ${variantStyle};
    ${hover};
    ${sizeStyle};

    ${({ isLoading }) =>
        isLoading &&
        css`
            pointer-events: none;
            ${Text.Style} {
                opacity: 0;
            }
        `}

    #loading {
        font-size: 20px;
        animation: ${rotation} 2s infinite linear;
        position: absolute;
        align-self: center;
    }
`;
